import { render, staticRenderFns } from "./caddies.vue?vue&type=template&id=439c3c25"
import script from "./caddies.vue?vue&type=script&lang=js"
export * from "./caddies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports